import { combineEpics } from 'redux-observable'
import { epic as accountEpic } from 'app/modules/account/epic'
import { epic as apiKeyEpic } from 'app/modules/apiKey/epic'
import { epic as assistantSettingsEpic } from 'app/modules/assistantSettings/epic'
import { epic as banEpic } from 'app/modules/ban'
import { epic as campaignsEpic } from 'app/modules/campaigns'
import { epic as cardsEpic } from 'app/modules/cards'
import { epic as classificationEpic } from 'app/modules/classification'
import { epic as composerEpic } from 'app/modules/composer'
import { epic as conversationEpic } from 'app/modules/conversation'
import { epic as csvEpic } from 'app/modules/csv'
import { epic as driftAppMetricsEpic } from 'app/modules/driftAppMetrics'
import { epic as embedEpic } from 'app/modules/embed'
import { epic as endUserEpic } from 'app/modules/endUser'
import { epic as gateEpic } from 'app/modules/gates'
import { epic as geolocationEpic } from 'app/modules/geolocation'
import { epic as googleAnalyticsEpic } from 'app/modules/googleAnalytics'
import { epic as integrationsEpic } from 'app/modules/integrations'
import { epic as inboxEpic } from 'app/modules/inbox'
import { epic as meetingEpic } from 'app/modules/meetings'
import { epic as messageEpic } from 'app/modules/message'
import { epic as notificationEpic } from 'app/modules/notification'
import { epic as orgEpic } from 'app/modules/org'
import { epic as overviewEpic } from 'app/modules/org/overview'
import { epic as participantsEpic } from 'app/modules/participants'
import { epic as playbookEpic } from 'app/modules/playbook'
import { epic as presenceEpic } from 'app/modules/presence'
import { epic as revealEpic } from 'app/modules/reveal'
import { epic as rulesEpic } from 'app/modules/rules'
import { epic as segmentEpic } from 'app/modules/segment'
import { epic as socketEpic } from 'app/modules/socket'
import { epic as tagsEpic } from 'app/modules/tags'
import { epic as targetingEpic } from 'app/modules/targeting'
import { epic as typingEpic } from 'app/modules/typing'
import { epic as userEpic } from 'app/modules/user'
import { epic as teamsEpic } from 'app/modules/teams'
import { epic as enrichmentEpic } from 'app/modules/enrichment'
import { epic as experimentEpic } from 'app/modules/experiment'
import { epic as externalAppEpic } from 'app/modules/externalApp'
import { epic as bulkUpdateConversationEpic } from 'app/modules/conversation/bulkUpdate'

const rootEpic = combineEpics(
  accountEpic,
  apiKeyEpic,
  assistantSettingsEpic,
  banEpic,
  campaignsEpic,
  cardsEpic,
  classificationEpic,
  composerEpic,
  conversationEpic,
  csvEpic,
  driftAppMetricsEpic,
  embedEpic,
  endUserEpic,
  enrichmentEpic,
  gateEpic,
  geolocationEpic,
  googleAnalyticsEpic,
  inboxEpic,
  integrationsEpic,
  meetingEpic,
  messageEpic,
  notificationEpic,
  orgEpic,
  overviewEpic,
  participantsEpic,
  playbookEpic,
  presenceEpic,
  revealEpic,
  rulesEpic,
  segmentEpic,
  socketEpic,
  tagsEpic,
  targetingEpic,
  teamsEpic,
  typingEpic,
  userEpic,
  experimentEpic,
  externalAppEpic,
  bulkUpdateConversationEpic,
)

export default rootEpic



// WEBPACK FOOTER //
// ./src/scripts/store/middleware/rootEpic.js